import React from 'react';
import { Divider } from '@mui/material';
import { CloseIcon } from 'src/components/SvgIcons/SvgIcons';
import Box from '@mui/system/Box';
import { SlRow } from 'src/components/BeaconV2Components/Generic/SlRow';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

/**
 * @returns the Product Growth modal header containing a 'Clear' button and X icon for closing the modal
 */
export const ProductGrowthFilterModalHeader = ({ handleClose }: { handleClose: () => void }) => {
  return (
    <>
      <SlRow
        horizontalInset="mdl"
        verticalInset="mdl"
        spacing="md"
        verticalPosition="center"
        horizontalPosition="space-between"
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }} />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '20px' // to center text in the modal header
          }}
        >
          <Text variant="h4">Filter</Text>
        </Box>
        <CloseIcon onClick={handleClose} style={{ cursor: 'pointer', width: '24px', height: '24px' }}></CloseIcon>
      </SlRow>
      <Divider />
    </>
  );
};
